import SortOrder from '~/client/src/shared/enums/SortOrder'

import { getResourceDefinition } from '../definitions'
import { IResourceUiConfig, RESOURCE_NAME_KEY } from '../definitions/types'

export const buildResourceUiConfig = (
  resourceTypeId?: string,
): IResourceUiConfig => {
  const definition = getResourceDefinition(resourceTypeId)

  if (!definition) {
    return {
      readOnlyPropertyNames: [],
      noneGroupingKey: 'none',
      defaultGroupingKey: 'none',
      defaultSortKey: RESOURCE_NAME_KEY,
      defaultSortOrder: SortOrder.ASC,
    }
  }

  const readOnlyPropertyNames = Object.entries(definition.fields)
    .filter(([, field]) => field.edit?.readOnly)
    .map(([key]) => key)

  return {
    readOnlyPropertyNames,
    noneGroupingKey: definition.ui.noneGroupingKey,
    defaultGroupingKey: definition.ui.defaultGroupingKey,
    pickerTreeGroupingKey: definition.ui.pickerTreeGroupingKey,
    pickerDefaultGroupingKey: definition.ui.pickerDefaultGroupingKey,
    pickerGroupings: definition.ui.pickerGroupings,
    defaultSortKey: definition.ui.defaultSortKey,
    defaultSortOrder: definition.ui.defaultSortOrder,
  }
}
